import React from 'react';
import PropTypes from 'prop-types';
import {PreciseStepper} from './PreciseStepper';
import {VagueStepper} from './VagueStepper';

import style from './style.module.scss';

export function Stepper(props) {
  const renderStepper = () => {
    switch (props.valueType) {
      case 'precise':
        return (
          <PreciseStepper
            currentValue={props.currentValue}
            onChange={props.onChange}
            min={props.min}
            max={props.max}
            step={props.step}
          />
        );
      case 'vague':
        return (
          <VagueStepper
            currentValue={props.currentValue}
            onChange={props.onChange}
            min={props.min}
            max={props.max}
            step={props.step}
          />
        );
      default:
        return;
    }
  };

  return <div className={style.stepper}>{renderStepper()}</div>;
}

Stepper.propTypes = {
  /**
   * string to be displayed in precise stepper
   */
  currentValue: PropTypes.string,
  /**
   * bool specifies if vague value provided
   */
  valueType: PropTypes.oneOf(['precise', 'vague']),
  ...PreciseStepper.propTypes,
  ...VagueStepper.propTypes,
};
